export default "__VITE_ASSET__rlT2paiV__"